import type { ServiceVersion } from '@repo/contracts';

import { useVersion } from '@/hooks/system/use-version';

const shortCommit = (commit: string): string => (commit === 'unknown' ? 'dev' : commit.slice(0, 7));

const describe = (entry: ServiceVersion): string =>
  `${entry.service}: ${entry.reachable ? shortCommit(entry.commit) : 'unreachable'}`;

/**
 * Deliberately a `title` attribute rather than a popover: this is the only
 * place in the app that would need one, and adding a dependency for a single
 * hover tooltip is not worth it — see AGENTS.md on extending @repo/ui, not
 * redefining primitives it does not have.
 */
export function BuildBadge() {
  const { data } = useVersion();

  const frontendCommit = shortCommit(import.meta.env.VITE_BUILD_COMMIT ?? 'unknown');
  const tooltip = data ? data.services.map(describe).join('\n') : 'Loading service versions…';

  return (
    <div className="px-4 pb-2">
      <p title={tooltip} className="truncate font-mono text-[11px] text-sidebar-muted-foreground">
        build {frontendCommit}
      </p>
    </div>
  );
}
